<template>
  <div class="products-list">
    <div class="row">
      <div class="col-sm-6 col-md-4 col-lg-4" v-for="(item, index) in productsList" :key="index">
        <CardTemplateDiscount :item="item" />
      </div>
    </div>
  </div>
</template>

<script>
import CardTemplateDiscount from '@/components/shared/CardTemplateDiscount';

export default {
  props: ['productsList'],
  components: { CardTemplateDiscount },
};
</script>
